/**
 * Hero Type 2 — background parallax.
 *
 * The prototype folded this into the same scroll handler that drives the
 * header's state. That handler is global and lives in _tlr-header.js, so
 * the banner's share of it is kept here instead: the header ships on every
 * page, the banner does not.
 *
 * Syntax note: gulp-babel runs with no preset, so this source reaches
 * uglify-js as written. No optional chaining (?.) or nullish coalescing
 * (??) — they break the build.
 */
(function () {
  // A collection, not an id: two banners on one page must not fight over
  // a single element, and the prototype's `#pbBg` would give them exactly
  // one to fight over.
  const layers = document.querySelectorAll(".hero2-bg");
  if (!layers.length) return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  let ticking = false;
  function apply() {
    const y = window.pageYOffset || document.documentElement.scrollTop;
    for (let i = 0; i < layers.length; i++) {
      layers[i].style.transform = "translateY(" + y * 0.22 + "px)";
    }
    ticking = false;
  }
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(apply);
  }
  window.addEventListener("scroll", onScroll, {
    passive: true
  });
  apply(); // restore the right state when reloading mid-page
})();